import { useState } from "react";
import { MailWarning } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

/** Shown on Add/Edit listing pages when the signed-in account's email isn't verified.
 *  Renders nothing for verified users, Google accounts, admins, or logged-out visitors. */
export default function EmailVerifyBanner() {
    const { user } = useAuth();
    const [sending, setSending] = useState(false);
    if (!user || user.email_verified) return null;

    const resend = async () => {
        setSending(true);
        try {
            await api.post("/auth/resend-verification");
            toast.success("Verification email sent — check your inbox (and spam).");
        } catch {
            toast.error("Couldn't send right now — please try again shortly.");
        } finally {
            setSending(false);
        }
    };

    return (
        <div data-testid="email-verify-banner" className="mb-6 border border-[#f59e0b]/40 bg-[#f59e0b]/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
            <MailWarning className="h-5 w-5 text-[#f59e0b] shrink-0" />
            <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-white">Verify your email to add or edit listings</div>
                <div className="text-xs text-[#d0b070] mt-0.5">
                    We sent a verification link to <span className="text-white">{user.email}</span>. Click it, then reload this page.
                </div>
            </div>
            <button
                data-testid="resend-verification-btn"
                onClick={resend}
                disabled={sending}
                className="shrink-0 px-4 py-2 text-[11px] uppercase tracking-[0.15em] bg-[#f59e0b] text-black font-semibold hover:bg-[#fbbf24] disabled:opacity-50"
            >
                {sending ? "Sending…" : "Resend email"}
            </button>
        </div>
    );
}
